import React, { useEffect, useState } from 'react'
import InfiniteScroll from 'react-infinite-scroll-component'
import { useDispatch, useSelector } from 'react-redux'
import {
  Button,
  CircularProgress,
  Drawer,
  IconButton,
  Typography,
  useMediaQuery
} from '@material-ui/core'
import {
  Close as CloseIcon,
  FilterList as FilterListIcon,
  Search as SearchIcon
} from '@material-ui/icons'
import { SearchWidget } from 'pages/HomePage/components'
import { BannerSection, Footer, MainLayout, NavBar, PageContainer } from 'shared'
import {
  loadSearchMetadata,
  search,
  setSearchParams as userAccountsSetSearchParams
} from 'state/modules/userAccounts'

import { FilterWidget, UserAccountCard } from './components'
import useStyles from './SearchPage.style'

const SEARCH_STATES = {
  SIMPLE_SEARCH: 'simpleSearch',
  MULTIPLE_SEARCH: 'multipleSearch'
}

const SearchPage = () => {
  const classes = useStyles()
  const dispatch = useDispatch()

  const { user } = useSelector((state) => state.auth)
  const {
    searchUserAccountsLastPage,
    searchParams: userAccountsSearchParams,
    searchUserAccounts,
    pending,
    searchMetadata,
    searchMetadataPending
  } = useSelector((state) => state.userAccounts)
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down('md'))

  const [filterDrawerOpen, setFilterDrawerOpen] = useState(false)
  const [showSearchPopupEl, setShowSearchPopupEl] = useState(null)

  const bannersPosition = isMobile ? 4 : 6

  useEffect(() => {
    dispatch(search(userAccountsSearchParams))
    dispatch(loadSearchMetadata(userAccountsSearchParams))
  }, [userAccountsSearchParams, dispatch, user])

  const doUserAccountsSearch = (newSearchParams) =>
    dispatch(userAccountsSetSearchParams(newSearchParams))

  return (
    <MainLayout>
      <NavBar
        showWidget
        widget={(props) => (
          <SearchWidget
            mini
            showSearchPopupEl={showSearchPopupEl}
            mode={SEARCH_STATES.MULTIPLE_SEARCH}
            setShowSearchPopupEl={setShowSearchPopupEl}
            {...props}
          />
        )}
      />
      <div className={classes.actionsContainer}>
        {!!userAccountsSearchParams.searchText && (
          <Typography
            color='primary'
            variant='h6'
            className={classes.text}
            title={`A continuación se muestran los resultados para la búsqueda: ${userAccountsSearchParams.searchText}`}>
            A continuación se muestran los resultados para la búsqueda:{' '}
            {userAccountsSearchParams.searchText}
          </Typography>
        )}
        <div className={classes.topActionsContainer}>
          <Button variant='text' color='primary' onClick={() => setFilterDrawerOpen(true)}>
            <span>Filtrar</span>
            <FilterListIcon />
          </Button>
          <IconButton color='primary' onClick={(e) => setShowSearchPopupEl(e.currentTarget)}>
            <SearchIcon />
          </IconButton>
        </div>
      </div>
      <PageContainer customContainerClassName={classes.container}>
        <div className={classes.filterContainer}>
          <div className={classes.filterWrapper}>
            <FilterWidget
              searchParams={userAccountsSearchParams}
              onSearchParamsChanged={doUserAccountsSearch}
              searchMetadata={searchMetadata}
              searchMetadataPending={searchMetadataPending}
            />
          </div>
        </div>
        <div className={classes.resultsContainer}>
          {!!searchUserAccounts.length && (
            <InfiniteScroll
              dataLength={searchUserAccounts.length}
              hasMore={!searchUserAccountsLastPage}
              next={() =>
                doUserAccountsSearch({
                  ...userAccountsSearchParams,
                  page: userAccountsSearchParams.page + 1
                })
              }
              style={{ overflow: 'inherit' }}
              className={classes.listContainer}>
              {searchUserAccounts.map((o, index) => (
                <>
                  {index === bannersPosition && (
                    <div className={classes.bannerContainer}>
                      <BannerSection />
                    </div>
                  )}
                  <div className={classes.cardContainer}>
                    <UserAccountCard key={o.id} userAccount={o} />
                  </div>
                </>
              ))}
            </InfiniteScroll>
          )}

          {pending && (
            <div className={classes.containerLoader}>
              <CircularProgress size={40} color='secondary' />
            </div>
          )}

          <div className={classes.endContainer}>
            {!pending && !searchUserAccounts.length && (
              <div className={classes.messageContainer}>
                <Typography variant='h5' color='primary'>
                  No hay resultados cargados para la búsqueda que indicaste.
                </Typography>
                <Typography color='primary'>
                  Para obtener más resultados te recomendamos que modifiques los parámetros de
                  búsqueda.
                </Typography>
              </div>
            )}

            <div className={classes.buttonsContainer}>
              {!pending && !searchUserAccountsLastPage && (
                <div className={classes.buttonContainer}>
                  <Button
                    color='primary'
                    variant='contained'
                    className={classes.button}
                    onClick={() => {
                      doUserAccountsSearch({
                        ...userAccountsSearchParams,
                        page: userAccountsSearchParams.page + 1
                      })
                    }}>
                    Ver más
                  </Button>
                </div>
              )}
            </div>
          </div>
        </div>
      </PageContainer>

      {isMobile && (
        <Drawer
          ModalProps={{
            keepMounted: true
          }}
          open={filterDrawerOpen}
          onClose={() => setFilterDrawerOpen(false)}
          anchor='left'>
          <div className={classes.filterWrapper}>
            <div className={classes.filterDrawerHeader}>
              <IconButton color='primary' onClick={() => setFilterDrawerOpen(false)}>
                <CloseIcon className={classes.closeIcon} />
              </IconButton>
            </div>
            <FilterWidget
              searchParams={userAccountsSearchParams}
              onSearchParamsChanged={doUserAccountsSearch}
              searchMetadata={searchMetadata}
              searchMetadataPending={searchMetadataPending}
            />
          </div>
        </Drawer>
      )}
      <Footer />
    </MainLayout>
  )
}

export default SearchPage
